import { getCharacter, type CharacterId } from '../content/characters';

export type ScoreRatio = Readonly<{ numerator: number; denominator: number }>;

export function chainRatio(chain: number): ScoreRatio {
  if (chain <= 1) return { numerator: 1, denominator: 1 };
  if (chain === 2) return { numerator: 5, denominator: 4 };
  if (chain === 3) return { numerator: 3, denominator: 2 };
  if (chain === 4) return { numerator: 7, denominator: 4 };
  if (chain === 5) return { numerator: 2, denominator: 1 };
  if (chain === 6) return { numerator: 9, denominator: 4 };
  return { numerator: 5, denominator: 2 };
}

export function roundPositiveRatioToTen(numerator: number, denominator: number): number {
  if (numerator < 0 || denominator <= 0) throw new RangeError('Score ratio must be positive');
  return Math.floor((numerator + denominator * 5) / (denominator * 10)) * 10;
}

export function normalGenerationScore(characterId: CharacterId): number {
  const character = getCharacter(characterId);
  return 10 * character.stage * (character.scoreCost + 1) * character.scoreMultiplier;
}

export function mergeScore(characterId: CharacterId, chain: number): number {
  const base = normalGenerationScore(characterId);
  const ratio = chainRatio(chain);
  return roundPositiveRatioToTen(base * ratio.numerator, ratio.denominator);
}

export function resonanceBonus(removedCharacterIds: readonly CharacterId[]): number {
  const normalTotal = removedCharacterIds.reduce(
    (total, characterId) => total + normalGenerationScore(characterId),
    0,
  );
  return roundPositiveRatioToTen(normalTotal, 4);
}
